export default "/images/1446adf7ddb65f7b233a875f147a9270.avif";